import generateHtmlElement from './generateHtmlElement';

const generateHtml = (rawText, annotations) => {
  let html = rawText;
  try {
    // split string into chars and a data structure to work with
    const representation = rawText.split('').map(char => ({ char, annotation: undefined }));
    // add annotations to the elements in the data structure
    annotations.forEach(annotation => {
      for (let i = annotation.index; i < annotation.index + annotation.length; i += 1) {
        const repAnnotaton = representation[i].annotation;
        // only accept one per char
        if (!repAnnotaton) {
          representation[i].annotation = annotation;
        }
      }
    });

    const nodes = [];

    // group chars by annotations
    const lastAcc = representation.reduce((acc, rep) => {
      const lastItem = acc[acc.length - 1];
      // first item, start a new "annotation group"
      if (!lastItem) {
        acc.push(rep);
        return acc;
      }
      // if other annotation compared to last, end the annotation group and start a new
      if (lastItem.annotation !== rep.annotation) {
        nodes.push(acc);
        return [rep];
      }
      // else just keep pushing to annotation group
      acc.push(rep);
      return acc;
    }, []);

    // if last annotation group ain't added to the nodes array, also add it.
    if (lastAcc && lastAcc.length > 0) {
      nodes.push(lastAcc);
    }

    // generate html elements from nodes array
    html = nodes
      .map(node => {
        const { annotation } = node[0];
        let text = node.map(element => element.char).join('');
        text = text?.replace('\n', '<br />') || text; // insert soft line break
        // do this node have annotations? If it does generate html tag for it.
        if (annotation) {
          return generateHtmlElement(text, annotation);
        }
        return text;
      })
      .join('');
  } catch (error) {
    console.error(error);
  }

  return html;
};

export default generateHtml;
